import React, { useEffect, useState } from 'react';
import * as Yup from "yup";
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import CustomLoading from '../../components/customLoading/CustomLoading';
import Table from '../../components/tables/Table';
import Breadcrumbs from '../../components/BreadCrumbs';
import Pagination from '../../components/tables/pagination/Pagination';
import Button from '../../components/buttons/Button';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { formatDateTime } from '../../utils/FormatDateTime';
import { getMarketingTemplateCampaignDetails, scheduleTemplateCampaign, startTemplatePost } from '../../services/notification_campaign';
import ShowModal from '../../utils/ShowModal';
import { Form, Formik } from 'formik';
import InputField from '../../components/inputFields/InputField';

function NotificationCampaignTemplateView() {
    const location = useLocation();
    const [rowData, setRowData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const headers = [
        { label: "S. No.", key: "i" },
        { label: "Started On", key: "created_at" },
        { label: "Logs", key: "logs" },
    ];

    const pageSize = 10;

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const fetchData = async (query) => {
        setLoading(true);
        try {
            let res = await getMarketingTemplateCampaignDetails(query || "");
            if (res.status === 200) {
                const data = res.data;
                setData(data);
            } else {
                toast.error("Unable to fetch Data");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching Data:", error);
        } finally {
            setLoading(false);
        }
    };

    const startCampaign = async () => {
        if (rowData.last_run_in_48_hours) {
            toast.warning("Campaign Already executed in last 48 hours");
        } else {
            toast.success("Starting Campaign");
            setLoading(true);
            try {
                let res = await startTemplatePost({
                    template: rowData.id,
                });
                if (res.status === 201) {
                    const data = res.data;
                    toast.success("Campaign Successfully Started");
                } else {
                    toast.error("Unable to fetch Data");
                }
                setLoading(false);
            } catch (error) {
                console.error("Error fetching Data:", error);
            } finally {
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        if (location.state) {
            setRowData(location.state);
            fetchData(`?template=${location.state.id}`);
        }
    }, [location]);

    const [modalIsOpen, setIsOpen] = useState(false);

    const openModal = () => {
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
    };

    const handleFormSubmit = async (values, { setSubmitting }) => {
        setSubmitting(true);
        try {
            const response = await scheduleTemplateCampaign({
                template: rowData.id,
                schedule_time: values.schedule_time,
            });

            if (response?.status === 200 || response?.status === 201) {
                toast.success("Campaign scheduled successfully");
            } else {
                let errors = "Opps! Something went wrong, please try again.";
                toast.error(errors);
            }
        } catch (error) {
            let errors =
                error?.response?.data?.error ||
                "Opps! Something went wrong, please try again.";
            toast.error(errors);
        }
        setSubmitting(false);
    };

    return (<>
        <Breadcrumbs items={[
            { name: 'Home', link: '/dashboard' },
            { name: 'Marketing' },
            { name: 'Notification Campaign', link: (-1) },
            { name: "Details" },
        ]} />
        <div className="flex flex-row justify-between item-center">
            <div className="py-4">
                <StyledHeadingText text={"Notifications"} />
            </div>
            <div className="flex flex-row items-center gap-4">
                <Button
                    type="button"
                    className="hover:bg-primary hover:opacity-70 text-white bg-green-500 rounded-md"
                    onClick={() => openModal()}
                    disabled={loading}
                >
                    Schedule for later
                </Button>
                <Button
                    type="button"
                    className="hover:bg-primary hover:opacity-70 text-white bg-green-500 rounded-md"
                    onClick={() => startCampaign()}
                    disabled={loading}
                >
                    Start Campaign
                </Button>
            </div>
        </div>
        {
            loading ?
                <div className="flex w-full flex-row justify-center my-2">
                    <CustomLoading size={100} />
                </div>
                :
                <div className="mt-2">
                    <Table
                        headers={headers}
                        rows={data?.results?.map((item, index) => (
                            {
                                i: <p>{index + 1}</p>,
                                logs: <span className='flex flex-row gap-1 items-center'><p className="max-w-4xl truncate cursor-help" logs={item.logs}>{item.logs}</p></span>,
                                created_at: <p>{formatDateTime(item.created_at)}</p>,
                            }))}
                    />
                </div>}
        {/* Table End */}
        {/* Pagination Begin */}
        {
            data.count !== 0 ?
                <Pagination
                    currentPage={currentPage}
                    
                    pageSize={pageSize}
                    totalEntries={data?.count}
                    onPageChange={handlePageChange}
                    data={data}
                    setData={setData}
                /> : <></>
        }
        <ShowModal contentLabel={"Notification Scheduler alert"} isOpen={modalIsOpen} modalWidth="30%" onRequestClose={closeModal} componentToPass={
            <div className="mt-8">
                <Formik
                    initialValues={rowData || {
                        title: "",
                        body: "",
                        redirect_screen: "",
                        category: "general",
                    }}
                    validationSchema={Yup.object({
                        schedule_time: Yup.string().required("Time is required"),
                    })}
                    onSubmit={handleFormSubmit}
                    enableReinitialize
                >
                    {({ isSubmitting, resetForm }) => (
                        <Form>
                            <div className="border border-gray-300 mt-5 p-4 rounded-lg bg-gray-100 flex flex-col md:flex-row gap-4">
                                <div className="flex flex-col w-full">
                                    <InputField
                                        label="Schedule Time"
                                        name="schedule_time"
                                        type="datetime-local"
                                        placeholder="DD-MM-YYYY HH:MM"
                                        required
                                    />
                                    <div className="py-5 flex justify-end gap-6">
                                        <div>
                                            <Button
                                                type="submit"
                                                className="text-white bg-primary hover:bg-primary-dark font-sm rounded-lg text-lg w-full px-8 py-1.5 text-center"
                                                disabled={isSubmitting}
                                            >
                                                {isSubmitting ? "Sending..." : "Save"}
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        } />
    </>);
}

export default NotificationCampaignTemplateView;